import React from "react";

export class Loader extends React.Component {
  render() {
    return <div className="loader" />;
  }
}
export default Loader;
